module.exports = __webpack_public_path__ + "static/media/sermon-mob.a63197e2.mp4";